var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMingcuteMore3Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:more-3-fill",
    clipPath: "url(#clip0_615_4501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 1.5C13.6423 1.5 17 4.85775 17 9C17 13.1423 13.6423 16.5 9.5 16.5C5.35775 16.5 2 13.1423 2 9C2 4.85775 5.35775 1.5 9.5 1.5ZM12.875 7.875C12.5766 7.875 12.2905 7.99353 12.0795 8.2045C11.8685 8.41548 11.75 8.70163 11.75 9C11.75 9.29837 11.8685 9.58452 12.0795 9.7955C12.2905 10.0065 12.5766 10.125 12.875 10.125C13.1734 10.125 13.4595 10.0065 13.6705 9.7955C13.8815 9.58452 14 9.29837 14 9C14 8.70163 13.8815 8.41548 13.6705 8.2045C13.4595 7.99353 13.1734 7.875 12.875 7.875ZM9.5 7.875C9.20163 7.875 8.91548 7.99353 8.7045 8.2045C8.49353 8.41548 8.375 8.70163 8.375 9C8.375 9.29837 8.49353 9.58452 8.7045 9.7955C8.91548 10.0065 9.20163 10.125 9.5 10.125C9.79837 10.125 10.0845 10.0065 10.2955 9.7955C10.5065 9.58452 10.625 9.29837 10.625 9C10.625 8.70163 10.5065 8.41548 10.2955 8.2045C10.0845 7.99353 9.79837 7.875 9.5 7.875ZM6.125 7.875C5.82663 7.875 5.54048 7.99353 5.3295 8.2045C5.11853 8.41548 5 8.70163 5 9C5 9.29837 5.11853 9.58452 5.3295 9.7955C5.54048 10.0065 5.82663 10.125 6.125 10.125C6.42337 10.125 6.70952 10.0065 6.9205 9.7955C7.13147 9.58452 7.25 9.29837 7.25 9C7.25 8.70163 7.13147 8.41548 6.9205 8.2045C6.70952 7.99353 6.42337 7.875 6.125 7.875Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_615_4501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteMore3Fill);
export default __webpack_public_path__ + "static/media/mingcute_more-3-fill.f6f00cbe43e98292f49157d2b00928bf.svg";
export { ForwardRef as ReactComponent };